import axios from 'axios';
import ListOrganizationEntitiesResponse = App.Data.Response.ListOrganizationEntitiesResponse;
import OrganizationTokenLookupResponse = App.Data.Response.OrganizationTokenLookupResponse;

export const getOrganizationEntities = async (
	organizationIdOrToken: string | number,
): Promise<ListOrganizationEntitiesResponse> => {
	const response = await axios.get(`/organizations/${organizationIdOrToken}/entities`);
	return response.data;
};

export const getOrganizationTokenData = async (organization: string): Promise<OrganizationTokenLookupResponse> => {
	const response = await axios.get(`/organization/${organization}`);
	return response.data;
};

export const createOrganizationEmployee = async (
	organizationId: number,
	data: App.Data.Request.OnboardNewUserRequest,
): Promise<void> => {
	await axios.post(`/organizations/${organizationId}/onboard-user`, data);
};
